import styled from '@emotion/styled';

export const HeaderWrap = styled.div`
  margin-bottom: 2rem;

  .warning {
    background: #000;
    color: #fff;
    padding: 8px 12px;
    margin: 20px 0;
    text-align: center;

    h2 {
      font-size: 16px;
      color: #fff;
      text-align: center;
    }

    p,
    h2 {
      margin: 0;
    }
  }
`;

export const CenteredDiv = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 12px;
`;

export const CheckboxWrap = styled.div`
  display: flex;
  justify-content: space-between;

  span {
    font-size: 12px;
  }
`;

export const Hrule = styled.hr`
  display: block !important;
  margin: 1.5em 0;
  width: 100%;
  border-width: thin;
`;

export const PhotoWrap = styled.div`
  .images {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  img {
    width: 280px;
    margin: 0.2rem;
  }
`;

export const AddBtn = styled.button`
  background: #fff;
  border: 1px solid #000;
  color: #000;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  text-decoration: none;
  padding: 0 1rem;
  min-width: 170px;
  min-height: 35px;
  cursor: pointer;
  font-size: 18px;
  margin: auto;

  &:hover {
    border: 2px solid #000;
  }

  span {
    display: flex;
    justify-content: space-between;

    img {
      margin-right: 5px;
    }
  }
`;

export const Subscript = styled.a`
  cursor: pointer;
  display: block;
  font-size: 14px;
  margin: 0;
  padding-top: 1.5rem;
  text-align: center;
  text-decoration: underline;
  width: 100%;
`;

export const Error = styled.p`
  color: #940420 !important;
  font-size: 12px;
  font-weight: bold;
`;
